import { render, staticRenderFns } from "./MakedQueue.vue?vue&type=template&id=00dfb7f4&scoped=true&"
import script from "./MakedQueue.vue?vue&type=script&lang=js&"
export * from "./MakedQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dfb7f4",
  null
  
)

export default component.exports